// extracted by mini-css-extract-plugin
export default {"cls1":"FeedbackModal-cls1_G7d","cls2":"FeedbackModal-cls2_yUF FeedbackModal-cls1_G7d"};